/* eslint-disable */
import styled, { injectGlobal } from 'styled-components';

import { mediaQueries } from '../../../../utils/styles';

import FiraSans from '../../../../assets/fonts/FiraSans.otf';
import FiraSansUltraLight from '../../../../assets/fonts/FiraSansUltraLight.otf';
import SanFrancisco from '../../../../assets/fonts/SanFrancisco.otf';
import Roboto from '../../../../assets/fonts/Roboto-Regular.ttf';
import RobotoMedium from '../../../../assets/fonts/Roboto-Medium.ttf';
import RobotoCondensed from '../../../../assets/fonts/RobotoCondensed-Regular.ttf';
import RobotoCondensedLight from '../../../../assets/fonts/RobotoCondensed-Light.ttf';
import RobotoThin from '../../../../assets/fonts/Roboto-Thin.ttf';
import RobotoBold from '../../../../assets/fonts/Roboto-Bold.ttf';

injectGlobal`
  @font-face {
    font-family: 'FiraSans';
    src: local('FiraSans'), url(${FiraSans}) format('opentype');
  }

  @font-face {
    font-family: 'FiraSansUltraLight';
    src: local('FiraSansUltraLight'), url(${FiraSansUltraLight}) format('opentype');
  }

  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'), url(${Roboto}) format('truetype');
  }

  @font-face {
    font-family: 'RobotoMedium';
    src: local('RobotoMedium'), url(${RobotoMedium}) format('truetype');
  }

  @font-face {
    font-family: 'RobotoCondensed';
    src: local('RobotoCondensed'), url(${RobotoCondensed}) format('truetype');
  }

  @font-face {
    font-family: 'RobotoCondensedLight';
    src: local('RobotoCondensedLight'), url(${RobotoCondensedLight}) format('truetype');
  }

  @font-face {
    font-family: 'RobotoThin';
    src: local('RobotoThin'), url(${RobotoThin}) format('truetype');
  }

  @font-face {
    font-family: 'RobotoBold';
    src: local('RobotoBold'), url(${RobotoBold}) format('truetype');
  }

  @font-face {
    font-family: 'SanFrancisco';
    src: local('SanFrancisco'), url(${SanFrancisco}) format('opentype');
  }

  html,
  body,
  #root {
    background-color: #E5EBF2;
    box-sizing: border-box;
    font-family: 'RobotoCondensed';
    overflow: auto;
    overflow-x: hidden;
  }

  html, body {
    min-height: 100%;
    padding: 0;
    margin: 0;
  }

  #root {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    ${mediaQueries.xs(`
      overflow-y: scroll;
    `)};
  }
`;

export const MainContainer = styled.div`
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/views/common/components/Root/styles.js